import type { CSSProperties, Ref } from "react";
import cx from "classnames";
import { DragIndicatorIcon } from "@ui-icons";

interface ResizeHandleProps {
  ref?: Ref<HTMLDivElement>;
  className?: string;
  style?: CSSProperties;
  isVeritcal?: boolean;
}

export function ResizeHandle({
  ref,
  className = "",
  style,
  isVeritcal,
}: ResizeHandleProps) {
  return (
    <div
      ref={ref}
      className={cx(
        "text-neutral hover:text-primary dark:hover:text-neutral-dark transition-colors group/arrow relative",
        // "in-[.panel-resizing]:bg-primary/5",
        isVeritcal ? "h-3 cursor-ns-resize" : "w-4 cursor-ew-resize",
        className
      )}
      style={style}
      data-test-id="resize-handle"
    >
      <div
        className={cx(
          "absolute bg-primary/5 hidden group-hover/arrow:block in-[.dragging]:block",
          isVeritcal ? "inset-x-0 inset-y-1" : "inset-y-0 inset-x-1"
        )}
      />
      {isVeritcal ? (
        <div className="flex items-center justify-center h-full">
          <DragIndicatorIcon sx={{ transform: "rotate(90deg)" }} />
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center h-full">
          <DragIndicatorIcon />
        </div>
      )}
    </div>
  );
}
